import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'

import { DependencyTree } from '../../../sca/libraries/components/dependency-tree'

const DependencyTreeWrapper = ({ organizationID, appID }) => {
  return (
    <DependencyTree organizationID={organizationID} applicationID={appID} />
  )
}

export const reactDependencyTree = createNgReactBridgeDirective(
  'reactDependencyTree',
  [],
  DependencyTreeWrapper,
  ['organizationID', 'appID']
)
